import times from 'lodash/times';

export const buildHoursOptions = () =>
  times(12).map(val => {
    const value = val + 1;
    return {
      value,
      label: `${value}`.padStart(2, '0'),
    };
  });

export const buildMinutesOptions = () =>
  times(60).map(value => ({
    value,
    label: `${value}`.padStart(2, '0'),
  }));
